export enum JobStatus {
  NotScheduled = 0,
  Scheduled = 1,
  InProgress = 2,
  Complete = 3,
  Canceled = 4
}
